const GetFormatTime = function(args){
    args = args || {};
    var t = args.time;
    var format = args.format;
    if (format == undefined) {
        format = "yyyy-MM-dd HH:mm:ss";
    }
    var _currentTime = new Date();
    try {
        if (t) {
            if (typeof t == "string") {
                t = t.replace(/\//g, "-");
                //_currentTime = new Date(t);//ios不支持
                var c_year = 1970,
                    c_month = 0,
                    c_day = 1,
                    c_hours = 0,
                    c_minutes = 0,
                    c_seconds = 0,
                    c_ms = 0;
                var list = t.replace("  ", " ").split(' ');
                var list1 = list[0].split("-");
                c_year = list1[0];
                c_month = parseInt(list1[1]) - 1;
                c_day = list1[2];
                if (list.length > 1) {
                    var list2 = list[1].split(":");
                    c_hours = list2[0];
                    if (list2.length > 1) {
                        c_minutes = list2[1];
                    };
                    if (list2.length > 2) {
                        var list3 = list2[2].split(".");
                        c_seconds = list3[0];
                        if (list3.length > 1) {
                            //由于后台数据库返回格式 实际是微秒 所以...暂时取前三位 当成毫秒数
                            c_ms = list3[1].substr(0, 3);
                        }
                    }
                };

                _currentTime = new Date(c_year, c_month, c_day, c_hours, c_minutes, c_seconds, c_ms);
            }
            else if (typeof t === "number") {
                _currentTime = new Date(t);
            }
            else {
                _currentTime = t;
            }
        };
    } catch (ex) { }

    function getNum(n) {
        return (n < 10 ? "0" : "") + n;
    }
    //yyyy|MM|dd|HH|mm:ss
    return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (v) {
        switch (v) {
            case "yyyy": return getNum(_currentTime.getFullYear());
            case "MM": return getNum(_currentTime.getMonth() + 1);
            case "dd": return getNum(_currentTime.getDate());
            case "HH": return getNum(_currentTime.getHours());
            case "mm": return getNum(_currentTime.getMinutes());
            case "ss": return getNum(_currentTime.getSeconds());
        }
    });
}

export const Now = function(d){
  var date = new Date();
  var hengGang = '-';
  var maoHao = ':';
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var curDate = date.getDate();
  if(d){
    if(d.indexOf('-')!=-1){
      date= date.setDate((date.getDate()-1))
      date = new Date(date)
      curDate = date.getDate();
    }else{
      date= date.setDate((date.getDate()+1))
      date = new Date(date)
      curDate = date.getDate();
    }
  }
  if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (curDate >= 0 && curDate <= 9) {
      curDate = "0" + curDate;
    }

  return year+hengGang+month+hengGang+curDate
}

export default GetFormatTime



// WEBPACK FOOTER //
// ./src/utils/time-format.js